<template>
    <div v-if="isEveryDaySame || weekDays.length > 0" class="checkin-checkout-times">
        <template v-if="isEveryDaySame">
            <span v-if="showLabel">{{ $t('pages.vehicle.pickup_return_label') }}</span>
            <strong>
                {{
                    $t('pages.vehicle.checkin_checkout_every_day', {
                        checkinTime: vehicle.checkinMonday,
                        checkoutTime: vehicle.checkoutMonday,
                    })
                }}
            </strong>
        </template>

        <template v-else>
            <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
            <p v-if="showLabel" class="checkin-checkout-times__label">{{ $t('pages.vehicle.pickup_return_label') }}:</p>
            <table class="checkin-checkout-times__table">
                <thead>
                    <tr>
                        <th />
                        <th class="checkin-checkout-times__table__border-cell">
                            {{ $t('vehicle_fields.time_checkin_label') }}
                        </th>
                        <th>{{ $t('vehicle_fields.time_checkout_label') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(day, index) in weekDays"
                        :key="day"
                        :class="{ 'checkin-checkout-times__table__last-row': index === weekDays.length - 1 }"
                    >
                        <th>{{ $t(`date_picker.days.${day.toLowerCase()}`) }}</th>
                        <td class="checkin-checkout-times__table__border-cell">{{ vehicle[`checkin${day}`] }}</td>
                        <td>{{ vehicle[`checkout${day}`] }}</td>
                    </tr>
                </tbody>
            </table>
        </template>
    </div>
</template>

<script>
export default {
    name: 'CheckinCheckoutTimes',
    props: {
        vehicle: {
            type: Object,
            default: () => {},
        },
        showLabel: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        };
    },
    computed: {
        isEveryDaySame() {
            if (!this.vehicle?.checkinMonday || !this.vehicle?.checkoutMonday) {
                return false;
            }

            const checkinTime = this.vehicle.checkinMonday;
            const checkoutTime = this.vehicle.checkoutMonday;

            return this.days.every(
                day => this.vehicle[`checkin${day}`] === checkinTime && this.vehicle[`checkout${day}`] === checkoutTime
            );
        },
        weekDays() {
            if (!this.vehicle) {
                return [];
            }

            return this.days.filter(day => this.vehicle[`checkin${day}`] && this.vehicle[`checkout${day}`]);
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/_variables.scss';

.checkin-checkout-times {
    &__table {
        margin-left: -16px;

        th,
        td {
            padding: 8px 16px;
        }

        thead th {
            @include font-size(14px);
            padding-top: 0;
        }

        &__last-row {
            th,
            td {
                padding-bottom: 0;
            }
        }

        th {
            font-weight: 600;
        }

        td {
            color: $secondary-text-color;
        }

        &__border-cell {
            border-right: 1px solid $border-color;
        }
    }
}
</style>
